<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Inspecciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Hidrocarburos</li>
                  <li class="breadcrumb-item active">Inspecciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card" style="display: inherit">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-11">
                    <h5>Inspecciones</h5>
                  </div>
                  <div class="col-md-1">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="save"
                        v-if="
                          $store.getters.can(
                            'hidrocarburos.inspecciones.create'
                          )
                        "
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                      <button
                        type="button"
                        class="btn bg-navy"
                        @click="getIndex()"
                      >
                        <i class="fas fa-sync"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-success"
                        @click="abrirModalExportar"
                        v-if="
                          $store.getters.can(
                            'hidrocarburos.reportes.exportInspecciones'
                          )
                        "
                        title="Exportar inspecciones"
                      >
                        <i class="fas fa-file-excel"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="card-body">
                  <h6>Filtros</h6>
                  <div class="row">
                    <div class="form-group col-md-2">
                      <label># Inspección</label>
                      <input
                        type="number"
                        v-model="filtros.id"
                        placeholder="# inspeccion"
                        label="id"
                        class="form-control form-control-sm"
                        @input="getIndex()"
                      />
                    </div>
                    <div class="form-group col-md-2">
                      <label># Viaje</label>
                      <input
                        type="number"
                        v-model="filtros.viaje_id"
                        placeholder="# viaje"
                        label="viaje_id"
                        class="form-control form-control-sm"
                        @input="getIndex()"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Rango Fechas</label>
                      <div class="row">
                        <div class="col-md-6">
                          <input
                            type="date"
                            class="form-control form-control-sm"
                            v-model="filtros.fecha_inicio"
                            @change="getIndex()"
                          />
                        </div>
                        <div class="col-md-6">
                          <input
                            type="date"
                            class="form-control form-control-sm"
                            v-model="filtros.fecha_fin"
                            @change="getIndex()"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Formato</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_formato_inspeccion"
                        placeholder="Formato Inspección"
                        label="nombre"
                        class="form-control form-control-sm p-0"
                        :options="formatos_inspeccion"
                        :filterable="false"
                        @search="buscarFormatosInspeccion"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Tipo de sitio</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="filtros.sitio_type"
                        @change="getIndex()"
                      >
                        <option value>Seleccione...</option>
                        <option
                          v-for="estado in listasForms.sitio_types"
                          :key="estado.numeracion"
                          :value="estado.numeracion"
                        >
                          {{ estado.descripcion }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="form-group col-md-3"
                      v-if="filtros.sitio_type2 == 'App\\PuntoGestion'"
                    >
                      <label>Punto Gestión</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_puntos_gestion"
                        placeholder="Puntos Gestión"
                        label="nombre"
                        class="form-control form-control-sm p-0"
                        :options="puntos_gestion"
                        :filterable="false"
                        @search="buscarPuntosGestion"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div
                      class="form-group col-md-3"
                      v-else-if="filtros.sitio_type2 == 'App\\Sitio'"
                    >
                      <label>Sitio</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_sitio"
                        placeholder="Sitio"
                        label="nombre"
                        class="form-control form-control-sm p-0"
                        :options="sitios"
                        :filterable="false"
                        @search="buscarSitios"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-3" v-else></div>
                    <div class="form-group col-md-5">
                      <label>Empresa</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_empresa"
                        placeholder="Empresas"
                        label="razon_social"
                        class="form-control form-control-sm p-0"
                        :options="empresas"
                        :filterable="false"
                        @search="buscarEmpresas"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Tipo Combustible</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.tipoCombustible"
                        placeholder="Combustible"
                        label="descripcion"
                        class="form-control form-control-sm p-0"
                        :options="listasForms.tiposCombustible"
                        :filterable="false"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Vehículo</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_vehiculo"
                        placeholder="Placa"
                        label="placa"
                        class="form-control form-control-sm p-0"
                        :options="vehiculos"
                        :filterable="false"
                        @search="buscarCabezotes"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-6">
                      <label>Conductor</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_conductor"
                        placeholder="Conductor"
                        label="nombre"
                        class="form-control form-control-sm p-0"
                        :options="conductores"
                        :filterable="false"
                        @search="buscarConductor"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Estado</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="filtros.estado"
                        @change="getIndex()"
                      >
                        <option value>Seleccione...</option>
                        <option
                          v-for="estado in listasForms.estados"
                          :key="estado.numeracion"
                          :value="estado.numeracion"
                        >
                          {{ estado.descripcion }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Estado Documento</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="filtros.estado_documento"
                        @change="getIndex()"
                      >
                        <option value>Seleccione...</option>
                        <option
                          v-for="estado in listasForms.estados_documentos"
                          :key="estado.numeracion"
                          :value="estado.numeracion"
                        >
                          {{ estado.descripcion }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="card-body table-responsive p-0">
                  <table
                    class="table table-bordered table-striped table-hover text-nowrap table-sm"
                    style="font-size: 0.85em"
                  >
                    <thead class="thead">
                      <tr>
                        <th class="text-center"># Insp.</th>
                        <th class="text-center">Viaje</th>
                        <th class="text-center">Solicitante</th>
                        <th class="text-center">Fecha</th>
                        <th class="text-center">Formato</th>
                        <th class="text-center">Tipo de sitio</th>
                        <th class="text-center">
                          {{
                            filtros.sitio_type2 == "App\\PuntoGestion"
                              ? "Punto Gestión"
                              : filtros.sitio_type2 == "App\\Sitio"
                              ? "Sitio"
                              : "Sitio/Punto Gestión"
                          }}
                        </th>
                        <th class="text-center">Empresa</th>
                        <th class="text-center">Vehículo</th>
                        <th class="text-center">Conductor</th>
                        <th class="text-center">Estado</th>
                        <th class="text-center">Est. Doc</th>
                        <th class="text-center">Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="inspeccion in inspecciones.data"
                        :key="inspeccion.id"
                      >
                        <td>{{ inspeccion.id }}</td>
                        <td class="text-center">
                          {{
                            inspeccion.viaje_id ? inspeccion.viaje_id : "Preop"
                          }}
                        </td>
                        <td class="text-center">
                          <span
                            class="badge bg-info"
                            v-if="
                              inspeccion.viaje_id &&
                              inspeccion.viaje.val_inspeccion
                            "
                          >
                            Web</span
                          >
                          <span
                            class="badge bg-navy"
                            v-else-if="inspeccion.responsable_id"
                          >
                            {{ inspeccion.responsable.name }}</span
                          >
                        </td>
                        <td>{{ inspeccion.fecha_inicio }}</td>
                        <td class="text-wrap">
                          {{
                            inspeccion.formato_inspeccion
                              ? inspeccion.formato_inspeccion.nombre
                              : ""
                          }}
                        </td>
                        <td>
                          {{
                            inspeccion.sitio_type == "App\\Sitio"
                              ? "Sitio"
                              : "Punto Gestion"
                          }}
                        </td>
                        <td>
                          {{ inspeccion.sitio ? inspeccion.sitio.nombre : "" }}
                        </td>
                        <td class="text-wrap">
                          {{
                            inspeccion.empresa
                              ? inspeccion.empresa.razon_social
                              : ""
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            inspeccion.vehiculo ? inspeccion.vehiculo.placa : ""
                          }}
                          <div>
                            <span
                              v-if="inspeccion.vehiculo != null"
                              class="badge ml-1 mr-1"
                              :class="
                                inspeccion.vehiculo.tipo_combustible == 1
                                  ? 'badge-warning'
                                  : 'badge-info'
                              "
                            >
                              {{ inspeccion.vehiculo.nCombustible }}
                            </span>
                          </div>
                        </td>
                        <td class="text-wrap">
                          {{
                            inspeccion.conductor
                              ? `${inspeccion.conductor.nombres} ${inspeccion.conductor.apellidos}`
                              : ""
                          }}
                        </td>
                        <td class="text-center">
                          <span
                            class="badge"
                            :class="[
                              inspeccion.estado == 1
                                ? 'badge-secondary'
                                : inspeccion.estado == 2
                                ? 'badge-success'
                                : inspeccion.estado == 3
                                ? 'badge-success'
                                : inspeccion.estado == 4
                                ? 'badge-danger'
                                : inspeccion.estado == 5
                                ? 'bg-olive'
                                : '',
                            ]"
                          >
                            {{
                              inspeccion.estado == 1
                                ? "Creada"
                                : inspeccion.estado == 2
                                ? "Aprobada"
                                : inspeccion.estado == 3
                                ? "Autorizada"
                                : inspeccion.estado == 5
                                ? "Aprobada con novedad"
                                : "Rechazada"
                            }}
                          </span>
                        </td>
                        <td class="text-center">
                          <span
                            class="badge"
                            :class="[
                              inspeccion.estado_documento == 1
                                ? 'badge-warning'
                                : 'badge-success',
                            ]"
                          >
                            {{
                              inspeccion.estado_documento == 1
                                ? "Borrador"
                                : "Definitivo"
                            }}
                          </span>
                        </td>
                        <td class="text-center">
                          <div class="btn-group">
                            <button
                              type="button"
                              class="btn btn-sm bg-navy"
                              v-if="
                                $store.getters.can(
                                  'hidrocarburos.inspecciones.show'
                                ) &&
                                (!inspeccion.viaje ||
                                  (inspeccion.viaje &&
                                    ([3, 4].includes(
                                      inspeccion.viaje.val_inspeccion
                                    ) ||
                                      !inspeccion.viaje.val_inspeccion)))
                              "
                              @click="edit(inspeccion.id)"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            
                            <button
                              type="button"
                              class="btn btn-sm bg-info"
                              v-if="
                                $store.getters.can(
                                  'hidrocarburos.inspecciones.revertir'
                                ) &&
                                inspeccion.estado == 2
                              "
                              @click="revertirInspeccion(inspeccion.id)"
                            >
                              <i class="fas fa-history"></i>
                            </button>
                            
                            <button
                              type="button"
                              class="btn btn-sm bg-danger"
                              v-if="
                                $store.getters.can(
                                  'hidrocarburos.inspecciones.verPdf'
                                )
                              "
                              @click="verPDF(inspeccion.id)"
                            >
                              <i class="fas fa-file-pdf"></i>
                            </button>
                          </div>
                          <br />
                          <span
                            v-if="
                              inspeccion.viaje &&
                              [1, 2].includes(inspeccion.viaje.val_inspeccion)
                            "
                            class="badge bg-warning mr-1"
                            >Sin verificar inspección</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer">
                  <div class="float-left" v-if="inspecciones.total">
                    <p>
                      Mostrando del
                      <b>{{ inspecciones.from }}</b> al
                      <b>{{ inspecciones.to }}</b> de un total:
                      <b>{{ inspecciones.total }}</b> Registros
                    </p>
                  </div>
                  <div class="float-left" v-else>
                    <p>
                      <span class="badge badge-danger"
                        >No hay registros para mostrar</span
                      >
                    </p>
                  </div>
                  <pagination
                    :data="inspecciones"
                    @pagination-change-page="getIndex"
                    :limit="5"
                    class="float-right"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Modal Exportar -->
    <div
      class="modal fade"
      id="modalExportarInspecciones"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      style="background-color: #00000082"
      @click.self="limpiarModalExportar"
    >
      <div class="modal-dialog modal-md" role="dialog">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h5 class="modal-title text-white">Exportar Inspecciones</h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              @click="limpiarModalExportar"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="form-group col-md-6">
                <label>Fecha Inicio <span class="text-danger">*</span></label>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="formExport.fecha_inicio"
                  :class="errorFecha ? 'is-invalid' : ''"
                  @change="validarFechasExport"
                />
                <div v-if="errorFecha" class="invalid-feedback">
                  {{ mensajeErrorFecha }}
                </div>
              </div>
              <div class="form-group col-md-6">
                <label>Fecha Fin <span class="text-danger">*</span></label>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="formExport.fecha_fin"
                  :class="errorFecha ? 'is-invalid' : ''"
                  @change="validarFechasExport"
                />
              </div>
              <div class="form-group col-md-12">
                <label>Formato</label>
                <v-select
                  :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                  v-model="formExport.slct_formato_inspeccion"
                  placeholder="Formato Inspección"
                  label="nombre"
                  class="form-control form-control-sm p-0"
                  :options="formatos_inspeccion"
                  :filterable="false"
                  @search="buscarFormatosInspeccion"
                ></v-select>
              </div>
              <div class="form-group col-md-12">
                <label>Empresa</label>
                <v-select
                  :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                  v-model="formExport.slct_empresa"
                  placeholder="Empresas"
                  label="razon_social"
                  class="form-control form-control-sm p-0"
                  :options="empresas"
                  :filterable="false"
                  @search="buscarEmpresas"
                ></v-select>
              </div>
              <div class="form-group col-md-12">
                <label>Placa Vehículo</label>
                <v-select
                  :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                  v-model="formExport.slct_vehiculo"
                  placeholder="Placa"
                  label="placa"
                  class="form-control form-control-sm p-0"
                  :options="vehiculos"
                  :filterable="false"
                  @search="buscarCabezotes"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="limpiarModalExportar"
            >
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="exportarSimple"
              :disabled="
                !formExport.fecha_inicio || !formExport.fecha_fin || errorFecha
              "
            >
              <i class="fas fa-file-excel"></i> Exportar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-undef */
import axios from "axios";
import Loading from "../../../../components/Loading";
import pagination from "laravel-vue-pagination";
import vSelect from "vue-select";

export default {
  name: "InspeccionIndex",
  components: {
    Loading,
    pagination,
    vSelect,
  },
  data() {
    return {
      storageKeyFiltros: "hidrocarburos_inspeccion_filtros",
      cargando: false,
      inspecciones: {},
      filtros: {
        id: null,
        viaje_id: null,
        fecha_inicio: null,
        fecha_fin: null,
        formato_inspeccion_id: null,
        punto_gestion_id: null,
        sitio_type: null,
        sitio_type2: null,
        empresa_id: null,
        tipoCombustible: null,
        vehiculo_id: null,
        conductor_id: null,
        estado: null,
        estado_documento: null,
      },
      listasForms: {
        slct_formato_inspeccion: [],
        slct_puntos_gestion: [],
        slct_sitio: [],
        slct_empresa: [],
        tiposCombustible: [],
        slct_vehiculo: [],
        slct_conductor: [],
        estados: [],
        estados_documentos: [],
        sitio_types: [],
      },
      formatos_inspeccion: [],
      puntos_gestion: [],
      sitios: [],
      empresas: [],
      vehiculos: [],
      conductores: [],
      formExport: {
        fecha_inicio: null,
        fecha_fin: null,
        slct_formato_inspeccion: null,
        slct_empresa: null,
        slct_vehiculo: null,
      },
      errorFecha: false,
      mensajeErrorFecha: "",
    };
  },
  methods: {
    getStoredFiltros() {
      try {
        const raw = sessionStorage.getItem(this.storageKeyFiltros);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    },
    setStoredFiltros() {
      try {
        const f = this.filtros;
        const payload = {
          filtros: {
            id: f.id,
            viaje_id: f.viaje_id,
            fecha_inicio: f.fecha_inicio,
            fecha_fin: f.fecha_fin,
            formato_inspeccion_id: f.formato_inspeccion_id,
            sitio_id: f.sitio_id,
            punto_gestion_id: f.punto_gestion_id,
            sitio_type: f.sitio_type,
            sitio_type2: f.sitio_type2,
            empresa_id: f.empresa_id,
            tipo_combustible: f.tipo_combustible,
            vehiculo_id: f.vehiculo_id,
            conductor_id: f.conductor_id,
            estado: f.estado,
            estado_documento: f.estado_documento,
          },
          slct_formato_inspeccion:
            this.listasForms.slct_formato_inspeccion &&
            this.listasForms.slct_formato_inspeccion.id
              ? {
                  id: this.listasForms.slct_formato_inspeccion.id,
                  nombre: this.listasForms.slct_formato_inspeccion.nombre || "",
                }
              : null,
          slct_sitio:
            this.listasForms.slct_sitio && this.listasForms.slct_sitio.id
              ? {
                  id: this.listasForms.slct_sitio.id,
                  nombre: this.listasForms.slct_sitio.nombre || "",
                }
              : null,
          slct_puntos_gestion:
            this.listasForms.slct_puntos_gestion &&
            this.listasForms.slct_puntos_gestion.id
              ? {
                  id: this.listasForms.slct_puntos_gestion.id,
                  nombre: this.listasForms.slct_puntos_gestion.nombre || "",
                }
              : null,
          slct_empresa:
            this.listasForms.slct_empresa && this.listasForms.slct_empresa.id
              ? {
                  id: this.listasForms.slct_empresa.id,
                  razon_social:
                    this.listasForms.slct_empresa.razon_social || "",
                }
              : null,
          tipoCombustible: this.filtros.tipoCombustible
            ? {
                numeracion: this.filtros.tipoCombustible.numeracion,
                descripcion: this.filtros.tipoCombustible.descripcion || "",
              }
            : null,
          slct_vehiculo:
            this.listasForms.slct_vehiculo && this.listasForms.slct_vehiculo.id
              ? {
                  id: this.listasForms.slct_vehiculo.id,
                  placa: this.listasForms.slct_vehiculo.placa || "",
                }
              : null,
          slct_conductor:
            this.listasForms.slct_conductor &&
            this.listasForms.slct_conductor.id
              ? {
                  id: this.listasForms.slct_conductor.id,
                  nombres: this.listasForms.slct_conductor.nombres || "",
                }
              : null,
        };
        sessionStorage.setItem(this.storageKeyFiltros, JSON.stringify(payload));
      } catch (e) {
        // sessionStorage no disponible
      }
    },
    clearStoredFiltros() {
      try {
        sessionStorage.removeItem(this.storageKeyFiltros);
      } catch (e) {
        // sessionStorage no disponible
      }
    },
    getIndex(page = 1) {
      this.cargando = true;
      const stored = this.getStoredFiltros();
      if (stored) {
        const f = stored.filtros;
        this.filtros.id = f.id ?? null;
        this.filtros.viaje_id = f.viaje_id ?? null;
        this.filtros.fecha_inicio = f.fecha_inicio || null;
        this.filtros.fecha_fin = f.fecha_fin || null;
        this.filtros.formato_inspeccion_id = f.formato_inspeccion_id ?? null;
        this.filtros.sitio_id = f.sitio_id ?? null;
        this.filtros.punto_gestion_id = f.punto_gestion_id ?? null;
        this.filtros.sitio_type = f.sitio_type ?? null;
        this.filtros.sitio_type2 = f.sitio_type2 || null;
        this.filtros.empresa_id = f.empresa_id ?? null;
        this.filtros.tipo_combustible = f.tipo_combustible ?? null;
        this.filtros.vehiculo_id = f.vehiculo_id ?? null;
        this.filtros.conductor_id = f.conductor_id ?? null;
        this.filtros.estado = f.estado ?? null;
        this.filtros.estado_documento = f.estado_documento ?? null;
        this.filtros.tipoCombustible = stored.tipoCombustible || null;
        if (this.filtros.sitio_type == 1)
          this.filtros.sitio_type2 = "App\\Sitio";
        else if (this.filtros.sitio_type == 2)
          this.filtros.sitio_type2 = "App\\PuntoGestion";
        this.listasForms.slct_formato_inspeccion =
          stored.slct_formato_inspeccion || null;
        this.listasForms.slct_sitio = stored.slct_sitio || null;
        this.listasForms.slct_puntos_gestion =
          stored.slct_puntos_gestion || null;
        this.listasForms.slct_empresa = stored.slct_empresa || null;
        this.listasForms.slct_vehiculo = stored.slct_vehiculo || null;
        this.listasForms.slct_conductor = stored.slct_conductor || null;
        this.clearStoredFiltros();
      } else {
        this.filtros.sitio_id = null;
        if (this.filtros.sitio_type) {
          if (this.filtros.sitio_type == 1) {
            this.filtros.sitio_type2 = "App\\Sitio";
            this.filtros.sitio_id = null;
            this.listasForms.slct_puntos_gestion = null;
            if (this.listasForms.slct_sitio) {
              this.filtros.sitio_id = this.listasForms.slct_sitio.id;
            }
          } else {
            this.filtros.punto_gestion_id = null;
            this.filtros.sitio_type2 = "App\\PuntoGestion";
            this.listasForms.slct_sitio = null;
            if (this.listasForms.slct_puntos_gestion) {
              this.filtros.sitio_id = this.listasForms.slct_puntos_gestion.id;
            }
          }
        } else {
          this.filtros.sitio_type2 = null;
          this.listasForms.slct_puntos_gestion = null;
          this.listasForms.slct_sitio = null;
        }
        this.filtros.formato_inspeccion_id = this.listasForms
          .slct_formato_inspeccion
          ? this.listasForms.slct_formato_inspeccion.id
          : null;
        this.filtros.empresa_id = this.listasForms.slct_empresa
          ? this.listasForms.slct_empresa.id
          : null;
        this.filtros.tipo_combustible = this.filtros.tipoCombustible
          ? this.filtros.tipoCombustible.numeracion
          : null;
        this.filtros.vehiculo_id = this.listasForms.slct_vehiculo
          ? this.listasForms.slct_vehiculo.id
          : null;
        this.filtros.conductor_id = this.listasForms.slct_conductor
          ? this.listasForms.slct_conductor.id
          : null;
      }

      // Se valida que la fecha de finalización no sea menor que la fecha de inicio
      if (this.filtros.fecha_inicio && this.filtros.fecha_fin) {
        this.validaFechas();
        this.cargando = false;
      }

      axios
        .get("/api/hidrocarburos/inspecciones?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.cargando = false;
          this.inspecciones = response.data;
        });
    },

    validaFechas() {
      const fecha_menor = new Date(this.filtros.fecha_inicio);
      const fecha_mayor = new Date(this.filtros.fecha_fin);
      // Se valida que la fecha inicial sea menor que la fecha final
      if (fecha_menor > fecha_mayor) {
        this.filtros.fecha_fin = null;
        this.$swal({
          icon: "error",
          title: `La fecha inicio no puede ser mayor a la fecha fin...`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    buscarPuntosGestion(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/puntos_gestion/lista?punto_gestion=" + search;
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.puntos_gestion = respuesta;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
    buscarSitios(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/sitios/lista?sitio=" + search;
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.sitios = respuesta;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarFormatosInspeccion(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url =
          "/api/admin/formatosInspeccion/lista?formato_inspeccion=" + search;
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.formatos_inspeccion = respuesta;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/empresas/lista?razon=" + search;
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.empresas = respuesta;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error - " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarCabezotes(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/vehiculos/lista?placa=" + search;
        axios
          .get(url)
          .then(function (response) {
            me.vehiculos = response.data;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error - " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarConductor(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/conductores/lista?nombre=" + search;
        axios
          .get(url)
          .then(function (response) {
            me.conductores = response.data;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error - " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    getTiposCombustibles() {
      axios.get("/api/lista/24").then((response) => {
        this.listasForms.tiposCombustible = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/38").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    getEstadosDocumentos() {
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados_documentos = response.data;
      });
    },

    save() {
      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          val: 0,
        },
      });
    },

    edit(inspeccion_id) {
      this.setStoredFiltros();
      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          inspeccion_id: inspeccion_id,
          params: {
            val: 0,
          },
        },
      });
    },

    revertirInspeccion(id) {
      this.$swal({
        title: "¿Está seguro de revertir la inspección " + id + "?",
        text: "La inspección volverá a estado borrador.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, revertir",
      }).then((result) => {
        if (result.value) {
          axios({
            method: "PUT",
            url: "/api/hidrocarburos/inspecciones/revertirInspeccion",
            data: { id },
          })
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Inspección revertida correctamente.",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
              });
              this.getIndex();
            })
            .catch((e) => {
              const msg =
                (e.response && e.response.data && e.response.data.message) ||
                "No se pudo revertir la inspección.";
              this.$swal({
                icon: "error",
                title: msg,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    //lista sitio type
    getSitioType() {
      // sitio 1, punto gestion 2
      axios.get("/api/lista/25").then((response) => {
        this.listasForms.sitio_types = response.data;
      });
    },

    verPDF(inspeccion_id) {
      this.cargando = true;
      axios({
        method: "get",
        url: "/api/hidrocarburos/inspecciones/pdf/" + inspeccion_id,
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          window.open(data.url, "_blank");
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    abrirModalExportar() {
      this.limpiarModalExportar();
      // Abrir modal usando JavaScript nativo
      const modal = document.getElementById("modalExportarInspecciones");
      if (modal) {
        modal.classList.add("show");
        modal.style.display = "block";
        document.body.classList.add("modal-open");
        // Crear backdrop
        const backdrop = document.createElement("div");
        backdrop.className = "modal-backdrop fade show";
        backdrop.id = "modalBackdropExportar";
        document.body.appendChild(backdrop);
      }
    },

    limpiarModalExportar() {
      this.formExport = {
        fecha_inicio: null,
        fecha_fin: null,
        slct_formato_inspeccion: null,
        slct_empresa: null,
        slct_vehiculo: null,
      };
      this.errorFecha = false;
      this.mensajeErrorFecha = "";
      // Cerrar modal usando JavaScript nativo
      const modal = document.getElementById("modalExportarInspecciones");
      if (modal) {
        modal.classList.remove("show");
        modal.style.display = "none";
        document.body.classList.remove("modal-open");
        // Remover backdrop
        const backdrop = document.getElementById("modalBackdropExportar");
        if (backdrop) {
          backdrop.remove();
        }
      }
    },

    validarFechasExport() {
      this.errorFecha = false;
      this.mensajeErrorFecha = "";

      if (!this.formExport.fecha_inicio || !this.formExport.fecha_fin) {
        return;
      }

      const fechaInicio = new Date(this.formExport.fecha_inicio);
      const fechaFin = new Date(this.formExport.fecha_fin);

      if (fechaInicio > fechaFin) {
        this.errorFecha = true;
        this.mensajeErrorFecha =
          "La fecha inicio no puede ser mayor a la fecha fin";
        return;
      }

      // Calcular la diferencia en días
      const diferenciaTiempo = fechaFin.getTime() - fechaInicio.getTime();
      const diferenciaDias = Math.ceil(
        diferenciaTiempo / (1000 * 60 * 60 * 24)
      );

      if (diferenciaDias > 31) {
        this.errorFecha = true;
        this.mensajeErrorFecha =
          "El rango de fechas no puede ser mayor a 31 días";
        return;
      }
    },

    exportarSimple() {
      // Validar fechas antes de exportar
      this.validarFechasExport();

      if (
        !this.formExport.fecha_inicio ||
        !this.formExport.fecha_fin ||
        this.errorFecha
      ) {
        this.$swal({
          icon: "error",
          title: "Por favor complete las fechas correctamente",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      this.cargando = true;

      // Preparar los filtros desde el modal
      let filtrosExport = {};

      // Fechas del modal (obligatorias)
      filtrosExport.fecha_inicio = this.formExport.fecha_inicio;
      filtrosExport.fecha_fin = this.formExport.fecha_fin;

      // Filtros opcionales del modal
      if (this.formExport.slct_formato_inspeccion) {
        filtrosExport.formato_inspeccion_id =
          this.formExport.slct_formato_inspeccion.id;
      }
      if (this.formExport.slct_empresa) {
        filtrosExport.empresa_id = this.formExport.slct_empresa.id;
      }
      if (this.formExport.slct_vehiculo) {
        filtrosExport.vehiculo_id = this.formExport.slct_vehiculo.id;
      }

      axios({
        method: "POST",
        url: "/api/hidrocarburos/inspecciones/exportSimple",
        params: filtrosExport,
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          this.limpiarModalExportar();
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },
  mounted() {
    this.getIndex();
    this.getEstados();
    this.getTiposCombustibles();
    this.getSitioType();
    this.getEstadosDocumentos();
  },
};
</script>
